package one.healthium.log_food.ui.camera

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.lifecycle.viewmodel.compose.LocalViewModelStoreOwner

@Composable
fun FoodCameraContent(component: FoodCameraComponent) {
    CompositionLocalProvider(LocalViewModelStoreOwner provides component) {
        FoodCameraScreen(component)
    }
}
